import React from 'react'
import PropTypes from 'prop-types'

const LevelsContext = React.createContext()
const PersonContext = React.createContext()

const LevelType = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
}

LevelsContext.Provider.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape(LevelType)),
}

PersonContext.Provider.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    school: PropTypes.shape({
      id: PropTypes.string.isRequired,
      tradeName: PropTypes.string.isRequired,
    }),
  }),
}

export { LevelsContext, PersonContext }
